var x = Object.defineProperty;
var E = (t, e, i) => e in t ? x(t, e, { enumerable: !0, configurable: !0, writable: !0, value: i }) : t[e] = i;
var o = (t, e, i) => (E(t, typeof e != "symbol" ? e + "" : e, i), i);
class k {
  constructor(e, i, s) {
    o(this, "iframe");
    o(this, "modal");
    o(this, "outer");
    o(this, "loader");
    o(this, "serverUrl");
    o(this, "onClosed");
    o(this, "config");
    this.serverUrl = e, this.config = i, this.loadStyles(), this.iframe = null, this.modal = null, this.outer = null, this.loader = null, this.onClosed = s;
  }
  createOuter() {
    this.outer = document.createElement("div"), this.outer.className = "pn-embed-modal-outer", document.body.appendChild(this.outer), this.outer.addEventListener("click", (e) => {
      e.target, this.outer;
    }), this.createCloseButton();
  }
  createModal() {
    this.modal = document.createElement("div"), this.modal.className = "pn-embed-modal", this.outer && this.outer.appendChild(this.modal);
  }
  createIframe() {
    this.iframe = document.createElement("iframe"), this.iframe.style.width = "100%", this.iframe.style.height = "100%", this.iframe.style.border = "none", this.iframe.style.display = "none", this.iframe.setAttribute("allowpaymentrequest", ""), this.iframe.setAttribute("allowfullscreen", ""), this.iframe.setAttribute("allow", "fullscreen; payment"), this.iframe.onload = () => {
    }, this.iframe.onerror = () => {
      console.error("Error loading iframe");
    };
  }
  getIframeInstance() {
    return this.iframe;
  }
  createLoader() {
    this.loader = document.createElement("div"), this.loader.className = "pn-embed-loader-container";
    const e = document.createElement("div");
    e.className = "pn-embed-logo-loader", this.loader.appendChild(e), this.modal && this.modal.appendChild(this.loader);
  }
  open(e) {
    this.outer || this.createOuter(), this.modal || this.createModal(), this.iframe || this.createIframe(), this.loader || this.createLoader(), this.iframe && this.modal && this.outer && (this.iframe.src = e, this.modal.appendChild(this.iframe), this.outer.style.display = "flex");
  }
  refresh(e) {
    this.open(e), this.showIframe();
  }
  close() {
    var e, i, s;
    this.outer && (this.outer.style.display = "none", (e = this.modal) == null || e.remove(), (i = this.iframe) == null || i.remove(), (s = this.loader) == null || s.remove(), this.modal = null, this.iframe = null, this.loader = null), this.onClosed && this.onClosed();
  }
  hideLoader() {
    this.loader && (this.loader.style.display = "none");
  }
  showIframe() {
    this.iframe && (this.iframe.style.display = "block");
  }
  createCloseButton() {
    const e = document.createElement("button");
    e.className = "pn-embed-modal-close-icon-btn", e.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90"><path fill="#fff" d="m49 45 14-14c.5-.5.8-1.3.9-2 .1-.8-.2-1.6-.7-2.1s-1.3-.8-2.1-.7c-.8 0-1.5.4-2 .9l-14 14-14-14c-.5-.5-1.3-.8-2-.9-.8-.1-1.6.2-2.1.7s-.8 1.3-.7 2.1c0 .8.4 1.5.9 2l14 14-14 14c-.5.5-.8 1.3-.9 2-.1.8.2 1.6.7 2.1s1.3.8 2.1.7c.8 0 1.5-.4 2-.9l14-14 14 14c.5.5 1.3.8 2 .9.8.1 1.6-.2 2.1-.7s.8-1.3.7-2.1c0-.8-.4-1.5-.9-2L49 45z"></path></svg>', e.onclick = () => {
      this.close();
    }, this.outer && this.outer.appendChild(e);
  }
  loadStyles() {
    const e = document.createElement("style");
    e.innerHTML = `
            .pn-embed-modal-outer {
                position: fixed;
                z-index: 2147483640;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.5);
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 50px;
                box-sizing: border-box;
            }
            .pn-embed-modal {
                width: 100%;
                height: 100%;
                background-color: transparent;
                border-radius: 8px;
                overflow: hidden;
                box-sizing: border-box;
            }
            
            .pn-embed-loader-container {
                width: 100%;
                height: 100%;
                box-sizing: border-box;
            }
            
            .pn-embed-logo-loader {
                display: block;
                overflow: hidden;
                position: absolute;
                background-size: 100%;
                background-position: 50%;
                background-repeat: no-repeat;
                height: 160px;
                width: 160px;
                left: calc(50% - 80px);
                top: calc(50% - 80px);
                background-image: url('${this.serverUrl}/embed/embed-loader.svg');
                animation: scaleInOut 3s infinite;
                transform-origin: 50% 50%;
                perspective: 1000px;
                box-sizing: border-box;
            }
            
            @keyframes scaleInOut {
                0% {
                    transform: scale(0.8) rotate(0deg);
                }
                50% {
                    transform: scale(1) rotate(12deg);
                }
                100% {
                    transform: scale(0.8) rotate(0deg);
                }
            }
            
            .pn-embed-modal-close-icon-btn {
              background: transparent;
              border: 0;
              cursor: pointer;
              height: 40px;
              position: fixed;
              right: 5px;
              top: 5px;
              width: 40px;
            }
        `, document.head.appendChild(e);
  }
}
function g(t) {
  window.addEventListener("message", t);
}
function I(t) {
  window.removeEventListener("message", t);
}
class W {
  constructor(e) {
    o(this, "isDebug");
    this.isDebug = e;
  }
  /**
   * Log a message
   */
  log(e) {
    this.isDebug && console.log(e);
  }
  /**
   * Log an error
   */
  error(e) {
    this.isDebug && console.error(e);
  }
  /**
   * Log a warning
   */
  warn(e) {
    this.isDebug && console.warn(e);
  }
  /**
   * Log an info message
   */
  info(e) {
    this.isDebug && console.info(e);
  }
  /**
   * Log a debug message
   */
  debug(e) {
    this.isDebug && console.debug(e);
  }
}
class L {
  constructor(e) {
    o(this, "modalWindow");
    o(this, "config");
    o(this, "url", "https://postnitro.ai/app");
    o(this, "callback");
    o(this, "carouselId", null);
    o(this, "logger");
    this.modalWindow = new k(this.url, e, () => {
      this.destroy();
    }), this.config = e, this.handleMessage = this.handleMessage.bind(this), this.callback = () => {
    }, this.carouselId = null, this.logger = new W(e.debug || !1);
  }
  createDesign(e) {
    this.carouselId = null, g(this.handleMessage), this.logger.debug("Event: API Key Verification (Embed)"), this.modalWindow.open(`${this.url}/_partnership/?api_key=${this.config.apiKey}`), this.callback = e;
  }
  editDesign(e, i) {
    this.carouselId = e, g(this.handleMessage), this.logger.debug("Event: API Key Verification (Embed)"), this.modalWindow.open(`${this.url}/_partnership/?id=${e}&api_key=${this.config.apiKey}`), this.callback = i;
  }
  // Method to handle incoming messages:
  handleMessage(e) {
    var i, s, l, h, c, m, u;
    if (e.data.type === "postnitro-embed-initialized") {
      this.logger.debug("Event: postnitro-embed-initialized (Embed)");
      const r = this.modalWindow.getIframeInstance(), a = window.location.origin;
      r && ((i = r.contentWindow) == null || i.postMessage(
        {
          type: "postnitro-config",
          data: {
            apiKey: this.config.apiKey,
            origin: a,
            partner: this.config.defaultHeadshot || void 0,
            debug: this.config.debug || !1
          }
        },
        this.url
      ));
    }
    if (e.data.type === "postnitro-embed-verified" && (this.logger.debug("Event: postnitro-embed-verified (Embed)"), this.modalWindow.hideLoader(), this.modalWindow.showIframe()), e.data.type === "sign-in") {
      e.data.url;
      const r = (s = window.screenLeft) != null ? s : window.screenX, a = (l = window.screenTop) != null ? l : window.screenY, f = (c = (h = window.innerWidth) != null ? h : document.documentElement.clientWidth) != null ? c : screen.width, b = (u = (m = window.innerHeight) != null ? m : document.documentElement.clientHeight) != null ? u : screen.height, n = f / window.screen.availWidth, w = (f - 500) / 2 / n + r, y = (b - 550) / 2 / n + a, d = window.open(
        this.url + "/google-signin",
        "Sign in with PostNitro",
        `width=${500 / n},height=${550 / n},top=${y},left=${w}`
      );
      if (d) {
        const v = setInterval(() => {
          if (d.closed) {
            clearInterval(v);
            let p = `${this.url}/_partnership/?api_key=${this.config.apiKey}`;
            this.carouselId && (p = `${this.url}/_partnership/?id=${this.carouselId}&api_key=${this.config.apiKey}`), this.modalWindow.refresh(p);
          }
        }, 500);
        d.focus();
      }
    }
    if (e.data.type === "editor-complete") {
      this.modalWindow.close(), this.destroy();
      const r = e.data.data;
      this.callback(r);
    }
    e.data.type === "refresh" && (this.logger.debug("Event: refresh (Embed)"), this.modalWindow.refresh(e.data.url));
  }
  // Don't forget to remove listener when you're done or the object is deconstructed to prevent memory leaks:
  destroy() {
    I(this.handleMessage);
  }
}
const $ = () => typeof window != "undefined";
function M(t) {
  return $() ? t.apiKey ? new L(t) : (console.error("API Key is required"), null) : null;
}
export {
  M as createEditor
};
//# sourceMappingURL=index.es.js.map
